import React from "react";

function DiscountIcon() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.25 2.25L2.25 16.25M6.25 3.75C6.25 5.13071 5.13071 6.25 3.75 6.25C2.36929 6.25 1.25 5.13071 1.25 3.75C1.25 2.36929 2.36929 1.25 3.75 1.25C5.13071 1.25 6.25 2.36929 6.25 3.75ZM17.25 14.75C17.25 16.1307 16.1307 17.25 14.75 17.25C13.3693 17.25 12.25 16.1307 12.25 14.75C12.25 13.3693 13.3693 12.25 14.75 12.25C16.1307 12.25 17.25 13.3693 17.25 14.75Z"
        stroke="#4072C8"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DiscountIcon;
